export const garantiasSectionKeys = [
    "tipoLastro",
    "alienacao",
    "cessao",
    "fianca",
    "hipoteca",
    "penhor",
    "avalista",
    "fundoObra",
    "fundoReserva",
    "fundoLiquidez",
    "sobregarantias",
    "seguro",
    "cotasInferiores",
    "patrimonioSeparado",
    "contaVinculada",
    "ltvNumerador",
    "ltvDenominador",
    "ltv"
]
